import loadScript from '@/commons/scriptLoad';
import store from '@/store';

let initialized = false;
let resolveProm: any;
let rejectProm: any;
const promise: any = new Promise((resolve, reject) => {
    resolveProm = resolve;
    rejectProm = reject;
});
export default function algolia(): any {
    if (initialized) {
        return promise;
    }
    initialized = true;
    const algoliaConfig = store.state.options.algolia;
    const algoliaRecommendConf = algoliaConfig.recommend;
    if(algoliaRecommendConf.frequentlyBoughtTogether.enabled ||
        algoliaRecommendConf.relatedProducts.enabled ||
        algoliaRecommendConf.trendingItems.enabled
    ) {
        const loadProms = [
            loadScript(algoliaConfig.libSdk, false),
            loadScript(algoliaConfig.searchSdk, false),
        ];
        Promise.all(loadProms).then(() => {
            const searchClient = algoliasearch(algoliaConfig.applicationId, algoliaConfig.apiKey);
            resolveProm({searchClient, algoliaConfig});
        });
    } else {
        rejectProm();
    }
    return promise;
}